import ProjectManagement from './ProjectManagement.vue'
export default ProjectManagement


// WEBPACK FOOTER //
// ./src/pages/ProjectManagement/index.js